<script>
import MetisMenu from "metismenujs/dist/metismenujs";
/**
 * Sidenav component
 */
export default {
  data() {
    return {
      menuItems: this.$store.state.menuItems,
      menuData: null,
    };
  },
  mounted: function () {
   // eslint-disable-next-line no-unused-vars
    new MetisMenu("#side-menu");
    // var links = document.getElementsByClassName("side-nav-link-ref");
    // var matchingMenuItem = null;
    // const paths = [];

    // for (var i = 0; i < links.length; i++) {
    //   paths.push(links[i]["pathname"]);
    // }
    // var itemIndex = paths.indexOf(window.location.pathname);
    // if (itemIndex === -1) {
    //   const strIndex = window.location.pathname.lastIndexOf("/");
    //   const item = window.location.pathname.substr(0, strIndex).toString();
    //   matchingMenuItem = links[paths.indexOf(item)];
    // } else {
    //   matchingMenuItem = links[itemIndex];
    // }

    // if (matchingMenuItem) {
    //   matchingMenuItem.classList.add("active");
    //   var parent = matchingMenuItem.parentElement;

    //   /**
    //    * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
    //    * We should come up with non hard coded approach
    //    */
    //   if (parent) {
    //     parent.classList.add("mm-active");
    //     const parent2 = parent.parentElement.closest("ul");
    //     if (parent2 && parent2.id !== "side-menu") {
    //       parent2.classList.add("mm-show");

    //       const parent3 = parent2.parentElement;
    //       if (parent3) {
    //         parent3.classList.add("mm-active");
    //         var childAnchor = parent3.querySelector(".has-arrow");
    //         var childDropdown = parent3.querySelector(".has-dropdown");
    //         if (childAnchor) childAnchor.classList.add("mm-active");
    //         if (childDropdown) childDropdown.classList.add("mm-active");

    //         const parent4 = parent3.parentElement;
    //         if (parent4 && parent4.id !== "side-menu") {
    //           parent4.classList.add("mm-show");
    //           const parent5 = parent4.parentElement;
    //           if (parent5 && parent5.id !== "side-menu") {
    //             parent5.classList.add("mm-active");
    //             const childanchor = parent5.querySelector(".is-parent");
    //             if (childanchor && parent5.id !== "side-menu") {
    //               childanchor.classList.add("mm-active");
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
  },

  // IDENTIFICA MENUS SEM ROTA
  // created() {
  //   const walk = (arr, path = []) => arr?.forEach((it, i) => {
  //     const name = it?.label ?? `#${i}`;
  //     const p = [...path, name];
  //     const isLeaf = !it?.subItems?.length;
  //     const hasTo = this.isValidTo(it?.link);
  //     const hasHref = !!it?.href;

  //     if (isLeaf && !hasTo && !hasHref) {
  //       console.warn('Menu folha sem rota nem href:', p.join(' > '), it);
  //     }
  //     if (!isLeaf) walk(it.subItems, p);
  //   });
  //   walk(this.menuItems);
  // },

  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */

    hasItems(item) {
      return item?.subItems?.length > 0;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },

    isValidTo(link) {
      if (!link) return false;
      if (typeof link === 'string') return link.trim().length > 0;
      if (typeof link === 'object') return Boolean(link.name || link.path);
      return false;
    },
  },

  computed: {
    qtdAssinaturasPendentes() {
      return this.$store.getters.assinaturasPendentesConselho;
    }
  }
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="(item, index) in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="index">
          {{ item.label }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="index">
          <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
            <i :class="`bx ${item.icon}`" v-if="item.icon && item.icon.includes('bx-')"></i>
            <i :class="`fa ${item.icon}`" v-else-if="item.icon && item.icon.includes('fa-')"></i>
            <i :class="`mdi ${item.icon}`" v-else></i>
            <span>{{ item.label }}</span>
            <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ item.badge.text
              }}</span>
          </a>

          <template v-else>
            <router-link v-if="isValidTo(item.link)" :to="item.link" class="side-nav-link-ref">

              <i :class="`bx ${item.icon}`" v-if="item.icon && item.icon.includes('bx-')"></i>
              <i :class="`fa ${item.icon}`" v-else-if="item.icon && item.icon.includes('fa-')"></i>
              <i :class="`mdi ${item.icon}`" v-else></i>

              <span v-if="item.id == 26 && qtdAssinaturasPendentes > 0">
                {{ item.label }} &nbsp; <b-badge class="rounded-circle bg-warning badge-notificacao">{{
                  qtdAssinaturasPendentes }}</b-badge>
              </span>
              <span v-else>{{ item.label }}</span>

              <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{
                item.badge.text
                }}</span>
            </router-link>
          </template>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">{{ subitem.label
                }}</router-link>
              <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{
                subitem.label }}</a>
              <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                  <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ subSubitem.label }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<style scoped>
  .badge-notificacao{
    color: #545a6d;
    font-weight: bold;
    font-size: 11px;
    width: 20px;
    height: 20px;
    padding: 4px;
    margin-top: 0;
  }

  #sidebar-menu ul li a i.fa-tractor {
    font-size: 1.09rem;
  }
</style>
